import React from 'react';
import { Button, FeaturedIcon } from '@myhealth-raccoon/components';
import { useLocation } from "react-router-dom";
import { useClinicSelector } from 'src/hooks/useAsyncSelector';
import { ContentContainer } from 'src/components/ContentContainer';
import { StickyBottomBar } from 'src/components/StickyBottomBar';

export function UnableToSchedAppointment() {
    const location = useLocation();
    const { bannedLevel } = location.state || {}; // Destructure passed state
    const { data: clinic } = useClinicSelector();

    return (<>
        <ContentContainer className='flex-1 lg:flex-none text-center space-y-6'>
            <FeaturedIcon size="lg" color="error" className="mb-8 mx-auto" />
            <h1 className="text-2xl text-gray-900 font-medium">
                We are currently unable to schedule an appointment for you
            </h1>
            {bannedLevel !== "Level 2" && (
                <p>
                    Please call the practice
                    {clinic?.phoneNumber ? `on ` : ''} <a className="text-primary" href={`tel:${clinic?.phoneNumber}`}>{clinic?.phoneNumber} </a>
                    to speak with one of our friendly receptionists to book with your doctor!
                </p>
            )}
            {bannedLevel === "Level 2" && (
                <p>
                    Please consult
                    <span className='text-primary'> <a href='https://www.healthdirect.gov.au'>https://www.healthdirect.gov.au</a> </span>
                    for alternative practice in the area
                </p>
            )}
        </ContentContainer>
        <StickyBottomBar>
            <Button className="w-full"
                color="gray"
                onClick={() => window.close()} >
                Exit
            </Button>
        </StickyBottomBar>
    </>
    );
}